import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { Grid, Menu } from 'semantic-ui-react';

const UsageStats = () => {
    return (
        <Grid>
            <Grid.Row>
                <Grid.Column>
                    <Menu borderless pointing secondary color='primary' stackable>
                        <Menu.Item as={NavLink} name='Texts' to={`texts`} />
                    </Menu>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column>
                    <Outlet />
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
}

export default UsageStats;
